export const SOCKET_STATE = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
  NULL: -1,
  REJECTED: 4,
};

export const SOCKET_EVENTS = {
  CLOSE: "close",
  OPEN: "open",
  ERROR: "error",
  MESSAGE: "message",
};

export const SOCKET_QUEUE_INTERVAL = 1000;
export const SOCKET_RECONNECT_INTERVAL = 3000;
export const SOCKET_IDLE_WATCH_INTERVAL = 4000;
export const SOCKET_ENUM = {
  ALIVE: 9000,
  BROADCAST_CHAT_CODE: "000",
};

export const SOCKET_PRIMARY_ROUTE = {
  CONTROL: ":",
  OPERATION: "$",
  COMM: "@",
  USER_LIST: "#",
  BROADCAST: "&",
};

export const MESSAGE_STATUS = {
  CLOSED: 5,
  OPEN: 0,
};

export function generateJsonRpcRequestPayload({
  id,
  method,
  params,
}: {
  id?: number;
  method: string;
  params?: Record<string, any>;
}) {
  return {
    jsonrpc: "2.0",
    id: id ?? getId(),
    method,
    params: params || {},
  };
}

export const getRandomInt = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

export function tryParseJSONObject(
  jsonString: string
): Record<string, any> | undefined {
  try {
    const o = JSON.parse(jsonString);
    if (o && typeof o === "object") {
      return o;
    }
  } catch {
    // Error is intentionally ignored
  }

  return undefined;
}

function CreateId() {
  let id = 0;
  return function () {
    return id++;
  };
}

export const getId = CreateId();
